import { render, staticRenderFns } from "./MessageSuggestion.vue?vue&type=template&id=02f297bd&scoped=true"
import script from "./MessageSuggestion.vue?vue&type=script&lang=js"
export * from "./MessageSuggestion.vue?vue&type=script&lang=js"
import style0 from "./MessageSuggestion.vue?vue&type=style&index=0&id=02f297bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f297bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
